<template>
	<div class="ticket-info-container">
		<mobile-card>
			<template v-slot:title>
				<div>{{ ticketNotifyText }}</div>
			</template>
			<template v-slot:content>
				<van-field
					v-model="detail.userEmail"
					clearable
					:label="emailText"
					label-align="left"
					:placeholder="emailPlaceholderText"></van-field>
			</template>
		</mobile-card>
	</div>
</template>
<script>
import mobileCard from '@/components/mobile-card/index'
import store from '@/store'

export default {
	name: 'ticketInfo',
	props: {
		detail: Object
	},
	components: {
		mobileCard
	},

	computed: {},
	data() {
		return {
			ticketNotifyText: this.$t('pay_ticket.ticket_notify'),
			emailText: this.$t('pay_ticket.email'),
			emailPlaceholderText: this.$t('pay_ticket.email_placeholder'),
			enableUseCompanyTitle: false,
			ticketType: '1',
			organ: {}
		}
	},

	activated() {
		this.enableUseCompanyTitle = this.$route.query.enableUseCompanyTitle
	},

	methods: {
		getTicketTitleAndTaxNum() {
			return {
				userMobile: this.detail.userMobile,
				userEmail: this.detail.userEmail
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.card-content .van-cell .van-field__label {
	width: 3em;
}
</style>
